import * as yup from "yup";

const emojiRegex =
  /[^\p{Script=Latin}\p{Mark}\p{Number}\p{Punctuation}\p{Separator}]+/u;

export default defineNuxtPlugin(() => {
  yup.addMethod(
    yup.string,
    "preventEmojis",
    function (message: yup.Message<any>) {
      return this.test("prevent-emojis", message, function (value, context) {
        if (value === undefined || value === null || value === "") {
          return true;
        }

        if (emojiRegex.test(value)) {
          return context.createError({
            message: message || "This field contains invalid characters.",
          });
        }

        return true;
      });
    },
  );
});
